import { noop } from './util';

/**
 * 사용 플래그 나중에 서버에서 받아오든 환경변수로 넣던
 */
const use = false;

const url = 'https://apply.pearbranch.com/login';

(() => {
  if (use) {
    (function(w, d, s, uri, fn) {
      w[fn] =
        w[fn] ||
        function() {
          var c = {};
          c.tenantApiUrl = arguments[0];
          c.tenantNFUrl = arguments[1];
          (w[fn].l = w[fn].l || []).push(c);
        };
      var o = d.createElement(s);
      var p = d.getElementsByTagName(s)[0];
      o.async = 1;
      o.charset = 'utf-8';
      o.src = uri;
      p.parentNode.insertBefore(o, p);
    })(
      window,
      document,
      'script',
      'https://agent-lib.surffy.io/surffy-agent_latest.js',
      'nfTag',
    );
    // eslint-disable-next-line no-undef
    nfTag(
      'https://nf-setting.surffy.io/chungp-2234/nf-setting.json',
      'https://chungp-2234.surffy.io',
    );
  }
})();

export const surffyProxy = callback => {
  if (use) {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line no-undef
      Surffy_Action(url, async () => {
        try {
          // eslint-disable-next-line no-undef
          const value = await callback(Surffy_Complete);
          resolve(value);
        } catch (error) {
          console.error(error);
          reject(error);
          // eslint-disable-next-line no-undef
          Surffy_Complete();
        }
      });
    });
  } else return callback(noop);
};
